/**
 * Central map of Google Analytics event names (GA4 custom events).
 * Prefer these constants over string literals at call sites.
 */
export const TRACKING_EVENTS = {
  POS_CHECKOUT: "pos_checkout",
  CART_ITEM_ADDED: "cart_item_added",
  CART_ITEM_REMOVED: "cart_item_removed",
  PAYMENT_METHOD_SELECTED: "payment_method_selected",
  SALE_FAILED: "sale_failed",

  INVENTORY_ADDED: "inventory_added",
  INVENTORY_BULK_UPLOAD: "inventory_bulk_upload",
  INVENTORY_ADJUSTED: "inventory_adjusted",
  LOW_STOCK_ALERT_VIEWED: "low_stock_alert_viewed",

  BARCODE_SCANNED: "barcode_scanned",
  BARCODE_FAILED: "barcode_failed",
  BARCODE_PRODUCT_NOT_FOUND: "barcode_product_not_found",
  BARCODE_AUTO_PRODUCT_CREATED: "barcode_auto_product_created",

  PRODUCT_CREATED: "product_created",
  PRODUCT_QUICK_CREATED: "product_quick_created",
  PRODUCT_UPDATED: "product_updated",

  PO_CREATED: "po_created",
  PO_RECEIVED: "po_received",

  ANALYTICS_OPENED: "analytics_opened",
  REORDER_SUGGESTION_CLICKED: "reorder_suggestion_clicked",
  GROWTH_INSIGHT_VIEWED: "growth_insight_viewed",

  PRICING_OVERRIDE_USED: "pricing_override_used",
  FIFO_AUTO_APPLIED: "fifo_auto_applied",

  FIRST_SALE_COMPLETED: "first_sale_completed",
  FIRST_INVENTORY_ADDED: "first_inventory_added",
} as const;

export type TrackingEventName = (typeof TRACKING_EVENTS)[keyof typeof TRACKING_EVENTS];
